import React from 'react';
import { capitalized } from '../utils';

interface GRAM_LIST_PROPS {
  data: { label: string; value: string }[] | string[];
  onChangeHandler: (val: string) => void;
  selected?: string;
  id: string;
}

export const Select = ({
  data,
  onChangeHandler,
  selected,
  id,
}: GRAM_LIST_PROPS): JSX.Element => {
  return (
    <select
      aria-label={id}
      id={id}
      className="bg-white px-4 py-2 border border-grey-300 rounded-md text-font-200 text-s-18 font-medium sm:text-s-14 "
      onChange={(e) => {
        onChangeHandler(e.target.value);
      }}
      value={selected}
    >
      {data.map((item) => {
        {
          return typeof item === 'string' ? (
            <option key={item} value={item}>
              {capitalized(item)}
            </option>
          ) : (
            <option key={item.label} value={item.value}>
              {item.label}
            </option>
          );
        }
      })}
    </select>
  );
};
